import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ReflectionLabel } from "@webapp/reflections/models/reflections.models";

@Component({
  selector: "reflection-label-group",
  templateUrl: "./reflection-label-group.component.html",
  styleUrls: ["./reflection-label-group.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReflectionLabelGroupComponent implements OnChanges {
  @Input() public labels?: ReflectionLabel[] = [];
  @Input() public maxVisible?: number = 2;

  public visibleLabels: ReflectionLabel[] = [];

  public hiddenLabels: ReflectionLabel[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    if ("labels" in changes || changes.maxVisible) {
      if (this.labels && this.labels[0] && this.labels[0].type === "notPublished") {
        this.visibleLabels = this.labels;
        return;
      }
      this.visibleLabels = this.labels?.slice(0, this.maxVisible);
      this.hiddenLabels = this.labels?.slice(this.maxVisible);
    }
  }
}
